// src/components/ProtectedRoute.jsx
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getUser } from "../redux/features/auth/authService";
import { selectUserDetails } from "../redux/features/auth/authSlice";
import GridLoader from "react-spinners/GridLoader";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { roleName, isLoggedIn, isUserDetailsLoading, hasCheckedAuth, details } =
    useSelector(selectUserDetails);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (!hasCheckedAuth) {
      dispatch(getUser());
    }
  }, [dispatch, hasCheckedAuth]);

  if (isUserDetailsLoading || !hasCheckedAuth) {
    return (
      <div className={`loader-style`}>
        <GridLoader color="#fcbf00" />
      </div>
    );
  }

  if(!details?.id  || !allowedRoles.includes(roleName)){
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  // if (!isLoggedIn) {
  //   return <Navigate to="/auth/login-verify" state={{ from: location }} replace />;
  // }

  return children;
};

export default ProtectedRoute;